// =====================================================================
// DOCUMENTI per compagnia × causale × pacchetto × società
// =====================================================================
// Filtra la lista documenti (caricati da DB) in base al contesto pratica.
// Restituisce solo i documenti applicabili, ordinati per `ordine`.

/**
 * @param {Array} documenti                     righe da compagnia_documenti
 * @param {Object} ctx                          contesto pratica
 * @param {string} ctx.causale                  'nuova' | 'usata' | 'rinnovo'
 * @param {string} ctx.pacchetto                'BASE' | 'PLUS' | ...
 * @param {boolean} ctx.is_societa              true se cliente è una società
 * @returns {Array} documenti filtrati e ordinati
 */
export function documentiApplicabili(documenti, { causale, pacchetto, is_societa } = {}) {
  if (!Array.isArray(documenti)) return []
  return documenti
    .filter(d => {
      // Filtro per causale (se specificato)
      if (Array.isArray(d.applicabile_causale) && d.applicabile_causale.length > 0) {
        if (!causale || !d.applicabile_causale.includes(causale)) return false
      }
      // Filtro per pacchetto (se specificato)
      if (Array.isArray(d.applicabile_pacchetto) && d.applicabile_pacchetto.length > 0) {
        if (!pacchetto || !d.applicabile_pacchetto.includes(pacchetto)) return false
      }
      // Filtro per società:
      //  - true  → richiesto SOLO se cliente è società
      //  - false → richiesto SOLO se cliente è privato (non società)
      //  - null/undefined → indifferente, sempre applicabile
      if (d.applicabile_societa === true && !is_societa) return false
      if (d.applicabile_societa === false && is_societa) return false
      return true
    })
    .sort((a, b) => (a.ordine ?? 100) - (b.ordine ?? 100))
}
